const DEFAULT_STATE = {
    currentStep: 0,
    tab2: null,
    tab3: null,
    tab4: null,
    tab5: null,
    attachment: {
        tab4: [],
        tab3: [],
    },
    submitted: false,
    loading: false,
    loadingMessage: '',
    application: {
        id: null,
        timestamp: new Date().getTime(),
    },
    draftId: null,
    isRenew: false,
};

const fnList = {
    UPDATE_TAB_DATA: (state, payload) => ({
        ...state,
        [`tab${payload.tabNumber}`]: payload.data,
    }),
    UPDATE_ATTACHMENT: (state, payload) => ({
        ...state,
        attachment: {
            ...state.attachment,
            [`tab${payload.tabNumber}`]: payload.attachment,
        },
    }),
    CHANGE_REGISTRATION_STEP: (state, payload) => ({
        ...state,
        currentStep: payload,
    }),
    RESET_REGISTRATION: state => ({
        ...state,
        tab2: null,
        tab3: null,
        tab4: null,
        tab5: null,
        attachment: {},
        submitted: false,
        loading: false,
        loadingMessage: '',
        isRenew: false,
        draftId: null,
    }),
    RESET_APPLICATION: state => ({
        ...state,
        application: {
            id: null,
            timestamp: new Date().getTime(),
        },
        tab2: null,
        tab3: null,
        tab4: null,
        tab5: null,
        attachment: {},
        submitted: false,
        loading: false,
        loadingMessage: '',
        draftId: null,
        isRenew: false,
    }),
    REGISTRATION_LOADING: (state, payload) => ({
        ...state,
        loading: payload,
    }),
    REGISTRATION_LOADING_MESSAGE: (state, payload) => ({
        ...state,
        loadingMessage: payload,
    }),
    APPLICATION_CREATED: (state, payload) => ({
        ...state,
        application: {
            id: payload,
            timestamp: new Date().getTime(),
        },
        loading: false,
        loadingMessage: '',
        draftId: null,
    }),
    CHANGE_DRAFT_ID: (state, payload) => ({
        ...state,
        draftId: payload,
    }),
    RENEW_APPLICATION: state => ({
        ...state,
        isRenew: true,
    }),
};
export default (state = DEFAULT_STATE, { type, payload }) => {
    const fn = fnList[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/registrationReducers.js
// module id = 1071
// module chunks = 0